// extracted by mini-css-extract-plugin
module.exports = {"btn":"HeaderIcon_btn__1ueWQ","activeNotifications":"HeaderIcon_activeNotifications__2jiDP","disactiveNotifications":"HeaderIcon_disactiveNotifications__396lJ"};